import { useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import graphql from "utils/api/graphql";
import { GO_BACKS } from "utils/constants";
import View from "./View";

const Create = () => {
  const navigate = useNavigate();
  const cancel = () => navigate(GO_BACKS.ONE);
  const [createRule] = useMutation(graphql.mutations.CREATE_RULE, {
    onCompleted: () => {
      navigate(GO_BACKS.ONE);
    },
    onError: () => {},
  });
  const onSubmit = ({ organization, name, action, crypto, fiat }) => {
    return createRule({
      variables: {
        data: {
          organization,
          name,
          action,
          configuration: {
            move: "fiat-to-crypto",
            ratio: 1,
            tokens: {
              crypto: { id: crypto },
              fiat: { id: fiat },
            },
          },
        },
      },
    });
  };
  return <View onSubmit={onSubmit} cancel={cancel} />;
};

export default Create;
